onmount = require("onmount");

$(document).on("turbolinks:load", function () {

  onmount("#js-ob-select-location", function () {
    $('#js-ob-select-location').on("change", function () {
      $('.js-location-services').addClass('d-none');

      var locationId = $('#js-ob-select-location').val();
      console.log(locationId)
      $('#location-'+locationId+'-services-list').removeClass('d-none');

    });
  });

  onmount();
});
